/**
 * DataSetInheritContext 链式工具：沿 parentContext 自叶向根收集再反转，
 * 供 propsStore 作用域 id、布局键前缀等单一出口使用。
 */

export type DataSetInheritContextLike = {
  index?: number;
  parentIndex?: number;
  parentContext?: DataSetInheritContextLike | null;
};

/**
 * 自根向叶排列的 context 链（根在 [0]）。
 * 方案文档中的 `flattenScopeChain` 与此为同一算法，保留双名以免调用方与文档不一致。
 */
export function collectContextChainRootToLeaf(
  ctx: DataSetInheritContextLike | null | undefined
): DataSetInheritContextLike[] {
  if (!ctx) return [];
  const rev: DataSetInheritContextLike[] = [];
  let cur: DataSetInheritContextLike | null | undefined = ctx;
  while (cur) {
    rev.push(cur);
    cur = cur.parentContext ?? null;
  }
  return rev.reverse();
}

/** @alias collectContextChainRootToLeaf — 与方案命名对齐 */
export const flattenScopeChain = collectContextChainRootToLeaf;

/**
 * 与历史 ReactFileGenerator 中 `ns` 一致：
 * `items_${parentIndex ?? index}_`，无有效下标时返回空串（顶层 ns(k) === k）。
 */
export function layoutKeyPrefixFromContext(
  ctx: DataSetInheritContextLike | null | undefined
): string {
  if (!ctx) return "";
  const row = ctx.parentIndex ?? ctx.index;
  if (row === undefined || !Number.isFinite(Number(row))) return "";
  return `items_${row}_`;
}
